<template>
  <div>
    <b-card>
      <b-card-header class="text-center"> Proventos </b-card-header>

      <b-table
        striped
        hover
        stacked="md"
        show-empty
        :items="aposentadoria.ProventoAposentadoria"
        :fields="computedFields"
      >
        <template #empty>
          <span>Não foram encontrados resultados.</span>
        </template>

        <template #cell(VlProvento)="data">
          {{ formatMoeda(data.item.VlProvento) }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script lang="ts">
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { Component, Vue } from "vue-property-decorator";
import { PropType } from "vue";
import { Aposentadoria } from "@/types/aposentadoria/aposentadoria";
import { TableField } from "@/types/table-field";

const CompProps = Vue.extend({
  name: "AbaProventos",
  props: {
    aposentadoria: {
      type: Object as PropType<Aposentadoria>,
      required: true,
    },
  },
});

@Component
export default class AbaProventos extends mixins(UtilsTS, CompProps) {
  //computeds
  get computedFields(): TableField[] {
    const fields: TableField[] = [
      {
        key: "DeProvento",
        label: "Descrição",
        tdClass: "quebrarPorPalavraHard, text-center",
        thClass: "text-center",
      },
      {
        key: "VlProvento",
        label: "Valor",
        tdClass: "quebrarPorPalavraHard, text-center",
        thClass: "text-center",
      },
    ];
    return fields;
  }
}
</script>
